import { AppState } from "../../common/store";
import { UserCV } from "../../users/model";
import { Page, SectionTypes } from "../models/models";

export const getPages = (state:AppState): Page[] => state.generator.pages;
export const getCvCopy = (state: AppState): UserCV | undefined => state.generator.cvCopy;
export const getSelectedSection = (state: AppState): SectionTypes | undefined => state.generator.selectedSection;
export const getInvisibles = (state: AppState): string[] => state.generator.invisibles;
export const getMinimizeds = (state: AppState): string[] => state.generator.minimizeds;
export const getInvisibleSections = (state: AppState): SectionTypes[] => state.generator.invisibleSections;